import { PDFStarSVG } from "@components/svgs/pdf-star";
import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";
import { useTheme } from "@mui/material";
import { Text, View } from "@react-pdf/renderer";

export const PDFEssentialNotice = () => {
  const { typographyStyle } = useAnalysisPDFStyles();
  const { palette } = useTheme();

  return (
    <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
      <PDFStarSVG />
      <Text
        style={{
          ...typographyStyle.body2,
          color: palette.common.black,
          paddingLeft: 2,
        }}
      >
        Essential feature
      </Text>
    </View>
  );
};
